<template>
  <div class="my-index-swiper-container" ref="mySwiperContainer" v-show="sliderWidthReady" :style="{ width: sliderWidth + 'px' }" v-if="promotions.length > 0">
    <swiper :options="swiperOptions" ref="mySwiper" class="index-slider">

      <swiper-slide :key="'s' + index" style="width: auto;" v-for="(promotion, index) in promotions">
        <div class="banner" :style="`background-image: url('${(isSmartphone ? promotion.acf.banner_mob : promotion.acf.banner)}');`"></div>
      </swiper-slide>

      <div class="index-slider-prev" slot="button-prev"><svg-inline :src="require('@/assets/icons/square-arrow-left.svg')" /></div>
      <div class="index-slider-next" slot="button-next"><svg-inline :src="require('@/assets/icons/square-arrow-right.svg')" /></div>
      <div class="index-slider-pagination" slot="pagination"></div>
    </swiper>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { forEach } from 'lodash'

  export default {
    name: 'MenuBannersSlider',
    data () {
      return {
        sliderWidthReady: false,
        sliderWidth: null
      }
    },
    computed: {
      ...mapGetters({
        promotions: 'content/promotions'
      }),
      swiperOptions () {
        return {
          slidesPerView: '1',
          spaceBetween: 0,
          initialSlide: 0,
          centeredSlides: false,
          navigation: {
            nextEl: '.index-slider-next',
            prevEl: '.index-slider-prev'
          },
          pagination: {
            el: '.index-slider-pagination',
            clickable: true
          },
          loop: true,
          simulateTouch: true,
          speed: 500,
          keyboard: {
            enabled: true,
            onlyInViewport: true
          },
          on: {
            init: () => {
              setTimeout(() => {
                forEach(document.querySelectorAll('.index-slider-pagination .swiper-pagination-bullet'), bullet => {
                  bullet.style.width = bullet.offsetHeight + 'px'
                  bullet.style.height = bullet.offsetHeight + 'px'
                })
              }, 100)
            }
          }
        }
      }
    },
    mounted () {
      this.$nextTick(() => {
        this.sliderWidth = document.querySelector('#right-content .adaptive-column-content').offsetWidth
        this.sliderWidthReady = true
      })
    }
  }
</script>



// WEBPACK FOOTER //
// src/blocks/MenuBannersSlider.vue